export interface TaskComponentConfig {
  allowStartTracking: boolean;
  allowSetUnapprovedTasksInProgress: boolean;
  headerFields: TaskComponentField[];
  contentFields: TaskComponentField[];
}

export interface TaskComponentField {
  labelTranslationKey?: string;
  field: string;
  fieldExpression?: string;
  linkIdField?: string;
  linkIdFieldExpression?: string;
  hideIf?: string;
}

export const DEFAULT_TASK_COMPONENT_CONFIG: TaskComponentConfig = {
  allowStartTracking: true,
  allowSetUnapprovedTasksInProgress: true,
  headerFields: [
    {
      field: "NAME"
    },
    {
      field: "AFOARTNAME",
      fieldExpression: "AFO_ART_ID.NAME"
    },
    {
      field: "ROOTNAME",
      fieldExpression: "LINK_ID.ROOT_ID.NAME"
    },
    {
      field: "PROJEKTNR"
    }
  ],
  "contentFields": [
    {
      field: "AFOBEZ",
      labelTranslationKey: "planning.task.description"
    },
    {
      field: "AFOARTNAME",
      fieldExpression: "AFO_ART_ID.NAME",
      labelTranslationKey: "planning.task.type"
    },
    {
      field: "RESNAME",
      fieldExpression: "RES_ID.TEXT",
      labelTranslationKey: "planning.task.resource"
    },
    {
      field: "ORDERNAME",
      fieldExpression: "PARENT.AUFTRAG_ID.TEXT",
      labelTranslationKey: "planning.task.order"
    },
    {
      field: "POSTEXT",
      fieldExpression: "LINK_ID.TEXT",
      labelTranslationKey: "planning.task.pos",
      linkIdField: "POSLINKID",
      linkIdFieldExpression: "LINK_ID",
      hideIf: "LINK_ID.HEAD_ID ! LINK_ID.ROOT_ID"
    },
    {
      field: "ROOTTEXT",
      fieldExpression: "LINK_ID.ROOT_ID.TEXT",
      labelTranslationKey: "planning.task.tool",
      linkIdField: "ROOTID",
      linkIdFieldExpression: "LINK_ID.ROOT_ID"
    },
    {
      field: "PARTNAME",
      fieldExpression: "LINK_ID.ROOT_ID.PARENT[TYP_ID.GUID=b514dea4-27fa-11b2-800a-b390cd5bbe84].TEXT",
      labelTranslationKey: "planning.task.part"
    },
    {
      field: "PROJECTNAME",
      fieldExpression: "LINK_ID.ROOT_ID.PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].TEXT",
      labelTranslationKey: "planning.task.project"
    }
  ]
}
